export default {
    RATIS_API_URL: 'https://api2.ratis.de/',
    TRACKING_URL: 'https://ratis.de/kba-anfrage-thx/',
};